import React from 'react';
import { formatLottoDate } from '../../utils/date';
import { getCountryFlag } from '../../utils/common';
import { renderLotteryLogo } from '../../utils/renderLotteryLogo';
import { useAssistantIntents } from '../../hooks/useLottoAssistantContext';
import ResultBalls from '../ResultBalls';
import classes from './LotteryResultCard.module.scss';

const LotteryResultCard = ({ lottery, from, to }) => {
  const { balls = [], draw_date: drawDate = 0 } = lottery.last_result ?? {};
  const { handleBettingOptionsRequest, handleDetailedLotteryResults } = useAssistantIntents();

  return (
    <div className={classes.Card}>
      <div className={classes.CardHeader}>
        <span className={classes.CountryBadge}>
          <span>{getCountryFlag(lottery.country)}</span>
          <span>{lottery.country}</span>
        </span>

        <div className={classes.LotteryInfo}>
          <div className={classes.LogoContainer}>{renderLotteryLogo(lottery.lottery_id)}</div>
          <div>
            <h4 className={classes.LotteryName}>{lottery.short_name}</h4>
            <p className={classes.DrawDate}>
              {formatLottoDate(drawDate).replace(' ', ' · ')}
            </p>
          </div>
        </div>
      </div>

      <hr className={classes.Divider} />

      <div className={classes.BallsSection}>
        <ResultBalls numbers={balls} />
      </div>

      <hr className={classes.Divider} />

      <div className={classes.CardFooter}>
        <button
          type="button"
          onClick={() =>
            handleDetailedLotteryResults(
              lottery.lottery_id,
              undefined,
              undefined,
              from,
              to
            )
          }
          className={classes.SecondaryButton}
        >
          More Results
        </button>
        <button
          type="button"
          onClick={() => handleBettingOptionsRequest(lottery.lottery_id)}
          className={classes.PrimaryButton}
        >
          Play
        </button>
      </div>
    </div>
  );
};

export default LotteryResultCard;
